// SHA-256 hex digest via the browser's native SubtleCrypto — no extra
// dependency, and one-way so the raw input never has to be sent anywhere.
export async function sha256Hex(value: string): Promise<string> {
  const encoded = new TextEncoder().encode(value);
  const digest = await crypto.subtle.digest("SHA-256", encoded);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}
